import { slugify } from './slugify';
import { getFlyerSuffix } from './flyers';
import { LinkData } from './common';
import { PAGE_CONTEXT } from './serverSideProps';

const flyersCategoriesListForSEO = [
  'All Flyers',
  'Groceries',
  'Restaurants',
  'Home & Garden',
  'Pharmacy',
  'General Merchandise',
  'Electronics',
  'Baby & Kids',
  'Fashion',
  'Automotive',
  'Sporting Goods',
  'Pets',
  'Office',
  'Specialty',
];

const couponsCategoriesListForSEO = ['All Deals', 'Baby', 'Grocery', 'Health & Beauty', 'Household', 'Pets', 'Other'];

export function getCategories(locale: string, context: PAGE_CONTEXT, location?: string): LinkData[] {
  let categoriesList = flyersCategoriesListForSEO;
  if (context === 'coupons') categoriesList = couponsCategoriesListForSEO;

  return categoriesList.map((name, index) => {
    const id = slugify(name);
    const word = context === 'coupons' ? 'coupon' : getFlyerSuffix(locale);
    const basicUrl = location ? `/${locale}/${location}/${word}s` : `/${locale}/${word}s`;
    const link = index === 0 ? basicUrl : `${basicUrl}/${id}`;
    return {
      id,
      name,
      link,
    };
  });
}

/* eslint-disable */
export function getFlyersCategoriesSlugToNameMapping(): { [uri: string]: string } {
  return {
    'all-flyers': 'All Flyers',
    groceries: 'Groceries',
    'home-and-garden': 'Home & Garden',
    pharmacy: 'Pharmacy',
    electronics: 'Electronics',
    'baby-and-kids': 'Baby & Kids',
    fashion: 'Fashion',
    automotive: 'Automotive',
    'sporting-goods': 'Sporting Goods',
    pets: 'Pets',
    office: 'Office',
    'black-friday': 'Black Friday',
    'back-to-school': 'Back to School',
    'boxing-day': 'Boxing Day',
    'general-merchandise': 'General Merchandise',
    specialty: 'Specialty',
    'online-only': 'Online Only',
    halloween: 'Halloween',
    thanksgiving: 'Thanksgiving',
    'cyber-monday': 'Cyber Monday',
    holidays: 'Holidays',
    'holiday-gifting': 'Holiday Gifting',
    christmas: 'Christmas',
    'new-years-eve': "New Year's Eve",
    'new-years': 'New Years',
    'valentines-day': "Valentine's Day",
    'presidents-day': "President's Day",
    easter: 'Easter',
    'mothers-day': "Mother's Day",
    'fathers-day': "Father's Day",

    tout: 'All Flyers',
    epicerie: 'Groceries',
    'maison-et-jardin': 'Home & Garden',
    pharmacie: 'Pharmacy',
    electronique: 'Electronics',
    'enfants-et-bebes': 'Baby & Kids',
    mode: 'Fashion',
    automobile: 'Automotive',
    sports: 'Sporting Goods',
    animaux: 'Pets',
    bureau: 'Office',
    'vendredi-fou': 'Black Friday',
    'le-lendemain-de-noel': 'Boxing Day',
    'la-rentree-scolaire': 'Back to School',
    'marchandises-generales': 'General Merchandise',
    specialite: 'Specialty',
    'uniquement-en-ligne': 'Online Only',
    // Duplicate identifier - Halloween is the same in EN and FR
    // "halloween": "Halloween",
    'action-de-grace': 'Thanksgiving',
    cyberlundi: 'Cyber Monday',
    'temps-des-fetes': 'Holiday Gifting',
    noel: 'Christmas',
    'veille-du-jour-de-lan': "New Year's Eve",
    'jour-de-lan': 'New Years',
    saintvalentin: "Valentine's Day",
    'jour-des-presidents': "President's Day",
    paques: 'Easter',
    'fetes-des-meres': "Mother's Day",
    'fetes-des-peres': "Father's Day",
    restaurants: 'Restaurants',
  };
}
export function getCouponsCategoriesSlugToNameMapping(): { [uri: string]: string } {
  return {
    'all-deals': 'All Deals',
    baby: 'Baby',
    grocery: 'Grocery',
    'health-and-beauty': 'Health & Beauty',
    household: 'Household',
    pets: 'Pets',
    other: 'Other',
    tout: 'All Deals',
    bebe: 'Baby',
    epicerie: 'Grocery',
    'sante-et-beaute': 'Health & Beauty',
    maison: 'Household',
    animaux: 'Pets',
    autre: 'Other',
  };
}
/* eslint-enable */
